import { Loader } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import React from "react";
import { useTranslation } from "react-i18next";

const TRANSLATION_KEY = "leads.importModal.processing";

interface Props {
  emailsCount: number;
}

const ImportProcessingContent: React.FC<Props> = ({ emailsCount }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="p-6 flex flex-col gap-6 items-center justify-center">
        <Text variant="bodySecondary">
          {t(`${TRANSLATION_KEY}.emails`, { count: emailsCount })}
        </Text>
        <IconContainer size="xl" color="primary">
          <Loader />
        </IconContainer>
        <Text variant="bodySecondary">{t(`${TRANSLATION_KEY}.enriching`)}</Text>
      </div>
      <div className="flex flex-col gap-1 items-center">
        <Text variant="lgBody">{t(`${TRANSLATION_KEY}.description1`)}</Text>
        <Text variant="lgBody">{t(`${TRANSLATION_KEY}.description2`)}</Text>
      </div>
    </div>
  );
};

export default ImportProcessingContent;
